module.exports = __webpack_public_path__ + "static/media/7_edullista-ja-puhdasta-energiaa.ba6dfd44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/7_edullista-ja-puhdasta-energiaa.svg
// module id = ./src/images/agendaIcons/7_edullista-ja-puhdasta-energiaa.svg
// module chunks = 1